<template>
    <div class="container-graphic">
        <section class="graphic-header">
            <span v-if="groupIcon" class="icon-group">
                <em :class="groupIcon" />

                <span class="tooltip">
                    {{ tooltipText }}

                    <a :href="tooltipLink" class="tooltip-link" target="_blank">
                        Saiba Mais
                        <em class="far fa-external-link" />
                    </a>
                </span>
            </span>

            <div class="title-subtitle">
                <div class="title">
                    <span class="title-text">{{ titleText }}</span>

                    <span class="title-text-arrow-bottom" />

                    <div v-if="isActionTitle" class="action-title">
                        <slot name="action-title" />
                    </div>
                </div>

                <div class="subtitle" :class="{'subtitle-active-actions': isActionTitle }">
                    <span class="subtitle-text" v-html="subtitleText" />
                </div>
            </div>

            <div v-if="isActionHeader" class="action-header">
                <slot name="action-header" />
            </div>
        </section>

        <section class="graphic-data">
            <div v-if="loading" class="loader">
                <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="50" :stroke="8" />
            </div>

            <slot v-show="!loading && !error" name="graphic-data" />

            <div v-if="error" class="hire-resource">
                <i class="fal fa-chart-bar" />

                <span class="no-data-display">
                    {{ noDataMessage }}
                </span>

                <a
                    v-if="hireResource"
                    :href="hireResourceLink"
                    class="hire-resource-link"
                    target="_blank">
                    Contrate este Recurso
                </a>
            </div>
        </section>
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

    export default {
        name: 'base-graphic',

		components: {
			uiLoadIndicator
		},

        props: {
			/**
			 * Utilize para adicionar um icone no grafico
			 */
			groupIcon: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um titulo ao grafico
			 */
			titleText: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um subtitle ao grafico
			 */
			subtitleText: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Utilize para adicionar um loading a tela
			 */
			loading: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Utilize para definir se o recurso deve ser contratado
			 */
			hireResource: {
				type: Boolean,
				required: false,
				default: false
			},
			/**
			 * Link para a tela com as informações para a contratação do recurso
			 */
			hireResourceLink: {
				type: String,
				required: false,
				default: '#'
			},
			/**
			 * Utilize para adicionar um link ao tooltip
			 */
			tooltipLink: {
				type: String,
				required: false,
				default: ''
			},
			/**
			 * Mensagem a ser mostrada no tooltip
			 */
			tooltipText: {
				type: String,
				required: false,
				default: 'O gráfico abaixo é atualizado em tempo real de acordo com a data de atualização.'
			},
			/**
			 * Mensagem a ser mostrada quando não houver informações ou ocorrer um erro ao
			 * buscar os dados
			 */
			noDataMessage: {
				type: String,
				required: false,
				default: 'Não há dados a serem exibidos'
			},
			/**
			 * Define se houve um erro ao trazer os dados
			 */
			error: {
				type: Boolean,
				required: false,
				default: false
			}
        },

		computed: {
			isActionTitle(){
				return this.$slots['action-title'] ? true : false
			},
			isActionHeader(){
				return this.$slots['action-header'] ? true : false
			}
		},
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>